import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements} from 'react-router-dom';
import { BASENAME } from '../config';

import { UserProvider } from './context/user-context/user-context';
import { CartProvider } from './context/cart-context/cart-context';

import { Layout } from '../components/layout/layout';
import { Catalog, catalogLoader } from '../components/catalog/catalog';
import { Cart } from '../components/cart/cart';
import { History, historyLoader } from '../components/history/history';
import { Search } from '../components/search/search';
import { Shipping } from '../components/shipping/shipping';
import { Checkout, checkoutLoader } from '../components/checkout/checkout';
import { Product, productLoader } from '../components/catalog/product/product';
import { Completed } from '../components/history/tabs/completed';
import { Success } from '../components/notifications/success/success';
import { RouteError } from '../components/errors/route-error/route-error';

import './App.css';
import { Failure } from '../components/notifications/failure/failure';
import { CheckParams } from './hoc/notifications/check-params';
import { Signin } from '../components/user/signin';
import { RequireAuth } from './hoc/user/RequireAuth';
import ErrorBoundary from '../components/errors/error-boundary/error-boundary';
import { NotFound } from '../components/errors/404/not-found';
import { SettingsProvider } from './context/settings-context/settings-context';


const router = createBrowserRouter(createRoutesFromElements(
  <Route path={`/`} element={<Layout />} errorElement={< RouteError />}>
    <Route index element={<Catalog />} loader={catalogLoader}/>
    <Route path="product/:id" element={<Product/>} loader={productLoader} />
    <Route path='cart' element={<Cart/>}/>
    <Route path='history/*' element={
      <RequireAuth>
        <History />
      </RequireAuth>
    } loader={historyLoader}>
        <Route path='completed' element={
          <RequireAuth>
            <Completed/>
          </RequireAuth>
        }/>
    </Route>
    <Route path='search' element={<Search />} />
    <Route path='shipping' element={<Shipping />}  />
    <Route path='checkout' element={<Checkout />} loader={checkoutLoader} />
    <Route path='success/:order' element={
      <CheckParams>
          <Success />
      </CheckParams>
    } />
    <Route path='failure/:order' element={
      <CheckParams>
        <Failure />
      </CheckParams>
    } />
    <Route path='signin' element={<Signin />} />
    <Route path='*' element={ <NotFound/> }/>
  </Route>
), {basename: BASENAME})


function App() {

  return (
    <SettingsProvider>
      <UserProvider>
          <CartProvider>
            <ErrorBoundary>
              <RouterProvider router={router}/>
            </ErrorBoundary>
          </CartProvider>
      </UserProvider>
    </SettingsProvider>
  );
}

export default App;
